import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./theme/grid.js";
import "./hooks/useBreakpoint.js";
import "react";
import { AnalyticsId, FormOnColor, IconSize } from "./constants.js";
import { getColor } from "./theme/currys/color.js";
import { L as LazyIcon } from "./LazyIcon.js";
import styles from "./components/StatusDot/styles.module.scss";
var StatusDotOnColor = ((StatusDotOnColor2) => {
  StatusDotOnColor2[StatusDotOnColor2["onwhite"] = FormOnColor.onwhite] = "onwhite";
  StatusDotOnColor2[StatusDotOnColor2["ondark"] = FormOnColor.ondark] = "ondark";
  return StatusDotOnColor2;
})(StatusDotOnColor || {});
var StatusDotVariant = /* @__PURE__ */ ((StatusDotVariant2) => {
  StatusDotVariant2["success"] = "success";
  StatusDotVariant2["inprocess"] = "inprocess";
  StatusDotVariant2["exception"] = "exception";
  StatusDotVariant2["unknown"] = "unknown";
  StatusDotVariant2["inspected"] = "inspected";
  StatusDotVariant2["cancelled"] = "cancelled";
  StatusDotVariant2["alert"] = "alert";
  StatusDotVariant2["transparent"] = "transparent";
  StatusDotVariant2["info"] = "info";
  StatusDotVariant2["group"] = "group";
  StatusDotVariant2["recurring"] = "recurring";
  StatusDotVariant2["noaccess"] = "noaccess";
  StatusDotVariant2["draft"] = "draft";
  StatusDotVariant2["hidden"] = "hidden";
  StatusDotVariant2["login"] = "login";
  StatusDotVariant2["attachment"] = "attachment";
  return StatusDotVariant2;
})(StatusDotVariant || {});
const StatusDotIcon = ({ onColor, variant = "info" }) => {
  const color = onColor === StatusDotOnColor.ondark ? getColor("white") : getColor("black");
  const iconProps = {
    color,
    size: IconSize.XXSmall,
    onColor,
    className: classNames({
      [styles[`statusdot__dot--${variant}`]]: typeof variant !== "undefined",
      [styles["statusdot__dot--on-dark"]]: onColor === StatusDotOnColor.ondark
    })
  };
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotSuccess" });
    case "inprocess":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotHalfDisc" });
    case "exception":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotWarningTriangle" });
    case "unknown":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotQuestionMark" });
    case "inspected":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotLookingGlass" });
    case "cancelled":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotCancelled" });
    case "alert":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotAlert" });
    case "transparent":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotTransparent" });
    case "info":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "DotInfo" });
    case "group":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "Group" });
    case "recurring":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "Change" });
    case "noaccess":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "NoAccess" });
    case "draft":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "Pencil" });
    case "hidden":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "NoEye" });
    case "login":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "Login" });
    case "attachment":
      return /* @__PURE__ */ jsx(LazyIcon, { ...iconProps, iconName: "Attachment" });
  }
  return null;
};
const StatusDot = (props) => {
  const { id, onColor = StatusDotOnColor.onwhite, variant = "info", text, className, testId } = props;
  const statusDotClasses = classNames(styles["statusdot"], className);
  const labelClasses = classNames(styles["statusdot__label"], {
    [styles["statusdot__label--on-dark"]]: onColor === StatusDotOnColor.ondark
  });
  return /* @__PURE__ */ jsxs("span", { id, className: statusDotClasses, "data-testid": testId, "data-analyticsid": AnalyticsId.StatusDot, children: [
    /* @__PURE__ */ jsx("span", { className: styles["statusdot__dot"], "data-testid": testId + "-dot", children: /* @__PURE__ */ jsx(StatusDotIcon, { onColor, variant }) }),
    /* @__PURE__ */ jsx("span", { className: labelClasses, children: text })
  ] });
};
export {
  StatusDot as S,
  StatusDotOnColor as a,
  StatusDotVariant as b
};
//# sourceMappingURL=StatusDot.js.map
